class ProductSwatches extends HTMLElement {
  constructor() {
    (super(),
      (this.productCard = this.closest(".card-wrapper, product-card")),
      (this.productForm = this.closest("product-form")),
      (this.isProductCard = !!this.productCard && !this.productForm),
      this.init());
  }
  init() {
    (this.setupEventListeners(),
      this.isProductCard
        ? this.setupProductCardBehavior()
        : this.setupProductPageBehavior());
  }
  setupEventListeners() {
    this.querySelectorAll(".product-swatch__input").forEach((input) => {
      input.addEventListener("change", this.handleSwatchChange.bind(this));
    });
  }
  handleSwatchChange(event) {
    const input = event.target,
      value = input.dataset.optionValue,
      position = input.dataset.optionPosition;
    (this.updateDisplayedValue(value),
      this.isProductCard
        ? (event.stopPropagation(), this.handleProductCardImageSwitch(input))
        : this.handleProductPageVariantSwitch(input),
      this.dispatchEvent(
        new CustomEvent("swatch:change", {
          bubbles: !0,
          detail: { value, position, input },
        }),
      ));
  }
  updateDisplayedValue(value) {
    let valueDisplay = this.querySelector(".product-swatches__value");
    (valueDisplay ||
      (valueDisplay = this.querySelector("[data-selected-value]")),
      valueDisplay ||
        (valueDisplay = (
          this.closest(".product-swatches") || this
        ).querySelector(".product-swatches__value")),
      valueDisplay && (valueDisplay.textContent = value));
  }
  setupProductCardBehavior() {
    this.storeOriginalImage();
  }
  storeOriginalImage() {
    if (!this.productCard) return;
    const mainImage = this.productCard.querySelector(".card img");
    mainImage &&
      !mainImage.dataset.originalSrc &&
      ((mainImage.dataset.originalSrc = mainImage.src),
      (mainImage.dataset.originalSrcset = mainImage.srcset || ""));
  }
  handleProductCardImageSwitch(input) {
    if (!this.productCard) return;
    const variantImageUrl = input.dataset.variantImage;
    if (!variantImageUrl) return;
    const mainImage = this.productCard.querySelector(".card img");
    mainImage &&
      ((mainImage.style.opacity = "0.5"),
      setTimeout(() => {
        mainImage.src = variantImageUrl;
        mainImage.srcset = input.dataset.variantImageSrcset || variantImageUrl;
        const variantTitle = input.dataset.optionValue;
        if (variantTitle) {
          const currentAlt = mainImage.alt;
          currentAlt.includes(variantTitle) ||
            (mainImage.alt = `${currentAlt} - ${variantTitle}`);
        }
        mainImage.style.opacity = "1";
      }, 150));
  }
  setupProductPageBehavior() {
    ((this.variantSelector = this.closest("variant-radios, variant-selects")),
      this.variantSelector &&
        this.variantSelector.addEventListener("variant:change", (event) => {
          this.updateSwatchSelection(event.detail);
        }));
  }
  handleProductPageVariantSwitch(input) {
    const variantImageUrl = input.dataset.variantImage,
      variantImageId = input.dataset.variantImageId;
    variantImageUrl &&
      this.switchProductPageImage(variantImageUrl, variantImageId);
    const variantId = input.dataset.variantId;
    if (variantId && this.productForm) {
      const hiddenInput = this.productForm.querySelector('input[name="id"]');
      hiddenInput &&
        ((hiddenInput.value = variantId),
        hiddenInput.dispatchEvent(new Event("change", { bubbles: !0 })));
    }
  }
  switchProductPageImage(imageUrl, imageId) {
    const productMediaWrapper = document.querySelector(
      ".product__media-wrapper, .product__media",
    );
    if (!productMediaWrapper) return;
    if (imageId) {
      const thumbnail = document.querySelector(
        `[data-media-id="${imageId}"], [data-target="${imageId}"], .product__media-item[data-media-id="${imageId}"]`,
      );
      if (thumbnail) {
        thumbnail.click();
        return;
      }
    }
    const mainImage = productMediaWrapper.querySelector(
      "img.product__image, img",
    );
    mainImage &&
      (mainImage.dataset.originalSrc ||
        ((mainImage.dataset.originalSrc = mainImage.src),
        (mainImage.dataset.originalSrcset = mainImage.srcset || "")),
      (mainImage.style.transition = "opacity 0.2s ease"),
      (mainImage.style.opacity = "0.5"),
      setTimeout(() => {
        mainImage.src = imageUrl;
        const baseSrc = imageUrl.split("?")[0];
        ((mainImage.srcset = `
          ${baseSrc}?width=493 493w,
          ${baseSrc}?width=600 600w,
          ${baseSrc}?width=713 713w,
          ${baseSrc}?width=823 823w,
          ${baseSrc}?width=990 990w,
          ${baseSrc}?width=1100 1100w,
          ${baseSrc}?width=1206 1206w,
          ${baseSrc}?width=1346 1346w,
          ${baseSrc}?width=1426 1426w,
          ${baseSrc}?width=1646 1646w,
          ${baseSrc}?width=1946 1946w
        `.trim()),
          (mainImage.style.opacity = "1"));
      }, 200));
    const slider = document.querySelector("slider-component");
    if (slider && imageId) {
      const slideIndex = Array.from(
        slider.querySelectorAll(".product__media-item"),
      ).findIndex((item) => item.dataset.mediaId === imageId);
      slideIndex !== -1 &&
        slider.slider &&
        slider.slider.scrollTo({
          left: slideIndex * slider.slider.offsetWidth,
          behavior: "smooth",
        });
    }
  }
  updateSwatchSelection(variantData) {
    if (!variantData || !variantData.options) return;
    const optionPosition = this.dataset.optionPosition;
    if (!optionPosition) return;
    const selectedValue = variantData.options[parseInt(optionPosition) - 1];
    if (!selectedValue) return;
    const matchingInput = this.querySelector(
      `.product-swatch__input[data-option-value="${selectedValue}"]`,
    );
    matchingInput &&
      !matchingInput.checked &&
      ((matchingInput.checked = !0), this.updateDisplayedValue(selectedValue));
  }
}
(customElements.get("product-swatches") ||
  customElements.define("product-swatches", ProductSwatches),
  document.addEventListener("variant:change", (event) => {
    const productForm = event.target.closest("product-form");
    if (!productForm) return;
    productForm.querySelectorAll("product-swatches").forEach((swatch) => {
      swatch.updateSwatchSelection &&
        swatch.updateSwatchSelection(event.detail);
    });
  }));
function updateSwatchAvailability(productId, availableVariantIds) {
  const productElement = document.querySelector(
    `[data-product-id="${productId}"]`,
  );
  if (!productElement) return;
  productElement.querySelectorAll(".product-swatch__input").forEach((input) => {
    const variantId = input.dataset.variantId;
    if (variantId) {
      const isAvailable = availableVariantIds.includes(parseInt(variantId));
      isAvailable
        ? input.removeAttribute("data-unavailable")
        : input.setAttribute("data-unavailable", "true");
      const label = input.nextElementSibling;
      label &&
        (isAvailable
          ? label.removeAttribute("data-unavailable")
          : label.setAttribute("data-unavailable", "true"));
    }
  });
}
window.ProductSwatches = { updateAvailability: updateSwatchAvailability };
